import React from "react"

export default ({className})  =>
  <svg className={className} data-name="Layer 1" viewBox="0 0 38 38" style={{width:'2rem', height: '3rem'}} >
    <circle
      cx={19}
      cy={19}
      r={18}
      fill="none"
      stroke="#313130"
      strokeMiterlimit={10}
      strokeWidth={2}
    />
    <path
      fill="none"
      stroke="#313130"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M26.99 15.01L19 22.99l-7.99-7.98"
    />
  </svg>


// WEBPACK FOOTER //
// ./src/svg/down-arrow-circle.js